module.exports = __webpack_public_path__ + "img/badge-1.656b5cf3.svg";